export function initAccordion() {
    const accordionContainers = document.querySelectorAll('.js-accordion');

    accordionContainers.forEach(container => {
        container.addEventListener('click', (e) => {
            const trigger = e.target.closest('.js-accordion-trigger');
            if (!trigger) return;

            const item = trigger.closest('.js-accordion-item');
            const content = item.querySelector('.js-accordion-content');
            const isOpen = item.classList.contains('is-open');

            if (isOpen) {
                item.classList.remove('is-open');
                content.style.maxHeight = null;
            } else {
                item.classList.add('is-open');
                content.style.maxHeight = content.scrollHeight + 'px';
            }
        });
    });
}

